module.exports = __webpack_public_path__ + "img/back.004bf9ac.svg";